import PropTypes from 'prop-types';
import React from 'react';

import {NewLookTheme} from 'web-app/styleguide/themes';

import {G, SVG} from '../svg';
import {Border} from './border';
import {type IconComponent} from './icon-component';

/**
 * @deprecated use MF icons
 */

export const ClosingDay: IconComponent<any> = ({bordered, transparent, fill, ...rest}) => (
    <SVG viewBox="0 0 500 500" radius={4} {...rest}>
        <G fill={bordered || transparent ? fill : 'white'}>
            <path d="M348,193.63c-.25-61.3-43.31-110.91-96.41-110.91-52.5,0-95.19,48.5-96.38,108.85a32.16,32.16,0,0,0-25.77,31.21l-1.5,159.07a32.15,32.15,0,0,0,31.85,32.46L338.15,416a32.16,32.16,0,0,0,32.46-31.85l1.5-159.07A32.14,32.14,0,0,0,348,193.63ZM271.74,349.84l-43.62-.42A7.2,7.2,0,0,1,222,338.57l13.59-23.13c-7.17-5.76-11.85-15.6-11.75-26.74C224,271.1,236,257,250.67,257.09s26.42,14.52,26.25,32.11c-.1,10.84-4.71,20.35-11.65,26l12.89,24A7.21,7.21,0,0,1,271.74,349.84ZM299,192.36l-97.88-.93a54.71,54.71,0,0,1-1.1-10.94c0-29.09,22.44-52.66,50.13-52.66s50.13,23.57,50.13,52.66A55.21,55.21,0,0,1,299,192.36Z" />
            {bordered && <Border color={fill} />}
        </G>
        <G fill={bordered || transparent ? 'transparent' : fill}>
            <path d="M250.13,127.83c-27.69,0-50.13,23.57-50.13,52.66a54.71,54.71,0,0,0,1.1,10.94l97.88.93a55.21,55.21,0,0,0,1.28-11.87C300.26,151.4,277.82,127.83,250.13,127.83Z" />
            <path d="M265.27,315.24c6.94-5.69,11.55-15.2,11.65-26,.17-17.59-11.58-32-26.25-32.11s-26.68,14-26.85,31.61c-.1,11.14,4.58,21,11.75,26.74L222,338.57a7.2,7.2,0,0,0,6.14,10.85l43.62.42a7.21,7.21,0,0,0,6.42-10.62Z" />
            <path d="M0,0V500H500V0ZM370.61,384.15A32.16,32.16,0,0,1,338.15,416l-178.41-1.69a32.15,32.15,0,0,1-31.85-32.46l1.5-159.07a32.16,32.16,0,0,1,25.77-31.21C156.35,131.22,199,82.72,251.54,82.72c53.1,0,96.16,49.61,96.41,110.91a32.14,32.14,0,0,1,24.16,31.45Z" />
        </G>
    </SVG>
);
ClosingDay.propTypes = {
    bordered: PropTypes.bool,
    transparent: PropTypes.bool,
    fill: PropTypes.string,
};
ClosingDay.defaultProps = {
    fill: NewLookTheme.primary,
};
export default ClosingDay;
